import React, { createContext, useContext, useState } from 'react';
import { TrackInsertions } from './utils/drag/types';
import { SnapPoint } from './utils/snap-points';

export type PreviewPosition = {
  id: string;
  trackIndex: number;
  from: number;
  durationInFrames: number;
};

export type PushedBackItemPreview = {
  id: string;
  trackIndex: number;
  originalFrom: number;
  newFrom: number;
  durationInFrames: number;
};

/** 트랜지션 드래그 프리뷰 정보 */
export type TransitionPreviewPosition = {
  id: string;
  from: number;
};

export type DragPreviewState = {
  positions: PreviewPosition[];
  trackInsertions: TrackInsertions | null;
  itemsBeingDragged: string[];
  snapPoint: SnapPoint | null;
  /** Magnetic 트랙에서 뒤로 밀리는 아이템들의 프리뷰 */
  pushedBackItems?: PushedBackItemPreview[];
  /** 드래그 중인 트랜지션들의 프리뷰 위치 */
  transitionPreviews?: TransitionPreviewPosition[];
};

const DragPreviewContext = createContext<DragPreviewState | null>(null);
const DragPreviewSetterContext = createContext<
  ((state: DragPreviewState | null) => void) | null
>(null);

export const DragPreviewProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [previewState, setPreviewState] = useState<DragPreviewState | null>(
    null,
  );

  return (
    <DragPreviewSetterContext.Provider value={setPreviewState}>
      <DragPreviewContext.Provider value={previewState}>
        {children}
      </DragPreviewContext.Provider>
    </DragPreviewSetterContext.Provider>
  );
};

export const useDragPreview = () => {
  const ctx = useContext(DragPreviewContext);
  return ctx;
};

export const useDragPreviewSetter = () => {
  const ctx = useContext(DragPreviewSetterContext);
  if (!ctx) {
    throw new Error(
      'useDragPreviewSetter must be used within DragPreviewProvider',
    );
  }
  return ctx;
};
